import React,{ useEffect, useState,useContext } from "react";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";


import "./CancelSubscriptionScreen.css"; // Import your CSS file for animations
import outer_eclipse from "../../assets/Images/cancel_trial_eclipse.png";
import outer_eclipse_svg from "../../assets/Images/cancel_eclipse.svg";
import credit_card from "../../assets/Images/cancel_close.png";
import { ToastContentProps, toast } from "react-toastify";
import {useSubscriptionCancedlMutation,useFintechLayouts,useActiveSubscriptions} from "../../services/AsaApiServices"
import {useBackButton} from '../../services/AsaSessionServices'

import showSubscriptionToast from "./SubscriptionToast"
import { AsaStateContext } from '../../components/AsaStateProvider'

import SubscriptionManagementBase from "./SubscriptionManagementBase"
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";

const formatDate = (dateString: string | number | Date,locale:string | undefined) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric", // Correctly typed as 'numeric'
    month: "long", // Correctly typed as 'long'
    day: "numeric", // Correctly typed as 'numeric'
  };
  const localeToUse = locale || "en-US"; // Default to 'en-US' if locale is undefined
  return new Date(dateString).toLocaleDateString(localeToUse, options);
};


const CancelSubscription = () => {
  const { t ,i18n} = useTranslation();
  const navigate = useNavigate();

  const fintechLaoyut=useFintechLayouts() //getLayoutFromFintech(fintech);
  const subscriptionCancelMutation= useSubscriptionCancedlMutation()
  const activeSubscriptions=useActiveSubscriptions()
  const activeSubscription=Array.isArray(activeSubscriptions?.data)?activeSubscriptions?.data?.[0]:undefined
  const backButton=useBackButton()
  const  [state, ] = useContext(AsaStateContext)
  const isAsaTransfer=state?.url?.toLowerCase().includes("asatransfer");
 useEffect(() => {
    AnalyticsService.track("Cancel Subscription Viewed", AnalyticsAction.View, AnalyticsFeature.Payment, {
      subscriptionName: activeSubscription?.subscriptionTitle,
      price: activeSubscription?.billingAmount,
    });
 }, []);

 useEffect(() => {
    try{
    
    if(!!!activeSubscription && !activeSubscriptions.isLoading){
      if(!!state.url){
        const currentUrl = new URL(state.url);
        
         navigate(currentUrl.pathname); 
      }else{
        backButton()
      }
       
    }
  }
  catch(error){
    console.log("error in subscription management",error)
  }
 }, [activeSubscription,activeSubscriptions.isLoading,state?.url]);

  const handleCancel = async () => {
    const billingDetailCode = activeSubscription?.billingDetailCode;

    if (!billingDetailCode) {
      console.error("BillingDetailCode is missing");
      return; // Exit if no billing detail code is available
    }

    const requestData = {
      BillingDetailCode: billingDetailCode,
    };

    try {
      await subscriptionCancelMutation.mutateAsync(requestData)
      AnalyticsService.track("Cancel Subscription Success", AnalyticsAction.API_Result, AnalyticsFeature.Payment, {
        subscriptionName: activeSubscription?.subscriptionTitle,
        price: activeSubscription?.billingAmount,
      });
      navigate("/cancelling", { state: { code:billingDetailCode } });
    } catch (error) {
      AnalyticsService.track("Cancel Subscription Error", AnalyticsAction.API_Result, AnalyticsFeature.Payment, {
        subscriptionName: activeSubscription?.subscriptionTitle,
        price: activeSubscription?.billingAmount,
      });
      console.error( error);
      showSubscriptionToast(t("failedToCancel", { error }), true);
    }
  };
const isFreeNoExpiry=(activeSubscription?.isFree??false) && !!!activeSubscription?.subscriptionEndDate
  return (
    <SubscriptionManagementBase>
             <div className="flex flex-col items-center justify-center flex-grow">
            <div className="dark:text-white text-[#4E4E4E] text-center font-poppins text-2xl font-medium leading-[20px] tracking-[-0.1px] mb-4"> {t(activeSubscription?.inTrial?"cancelTrialTitle":"cancelPlanTitle")}</div>
            <div className="relative p-4 rounded-full">
              <img
                src={outer_eclipse_svg} // replace with your outer circle image
                alt="Outer Circle"
                className="h-50 w-50" // Adjust size as needed
              />
              <img
                src={credit_card} // replace with your credit card image
                alt="Credit Card"
                className="absolute inset-0 h-24 w-24 m-auto p-2" // Center the credit card and add padding
              />
            </div>
            <p className=" dark:text-white text-[#4E4E4E] text-center font-poppins text-sm font-normal font-semibold
              leading-6 tracking-[-0.1px]  mb-2">{t("areYouSureCancel")}</p>{" "}
            <p className="mx-4 dark:text-white text-[#4E4E4E]  text-center font-poppins text-xs font-semibold leading-[20px] tracking-[-0.1px] opacity-50">
            {isFreeNoExpiry
            ? t("freePlanNeverExpires")
            : isAsaTransfer? t("cancelNoLongerBill"): t("accessUntil") }
            
            </p>
            { !isFreeNoExpiry  &&  !isAsaTransfer &&
            <p className=" dark:text-white text-[#4E4E4E]  text-center font-poppins text-xs font-semibold leading-[20px] tracking-[-0.1px] opacity-50">{activeSubscription?.subscriptionEndDate                          ? formatDate(activeSubscription?.subscriptionEndDate,i18n.language)
                          : t("subscriptionEndDate")}</p>
            }
          </div>
          {/* Buttons */}
          <div className="flex justify-between px-6 py-4 space-x-4">
            <button
              className="manage-trial-btn-cancel"
              style= {fintechLaoyut?.buttonStyle }
              onClick={()=>navigate(-1)}
              
            >
              {t("goBack")}
            </button>
            <button
              className=" rounded-[10px] border dark:border-white border-[#4E4E4E] bg-[rgba(70,182,1,0)] shadow-[0px_4px_4px_rgba(0,0,0,0.25)]
                w-1/2 dark:text-white text-[#4E4E4E]  py-2 px-0 font-poppins font-bold text-[14px] leading-[20px]
                tracking-[-0.1px]  text-center align-middle  uppercase"
              onClick={handleCancel} // Add the click handler
            >
               {t(activeSubscription?.inTrial?"cancelTrial":"cancelPlan")}
              
            </button>
          </div>
    </SubscriptionManagementBase>

 
  );
};

export default CancelSubscription;
